import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ProjectOverlayPlanDetails from "./plan-details";
import ProjectFilePlanContextProvider from "./plan-details/context/project-file-plan-context-provider.tsx";
import ModelingToolsContextProvider from "../../../../../services/context/viewer/modeling-tools/modeling-tools-context-provider.tsx";
import MeasureOverviewLayout from "../../measures/layouts/overview/index.tsx";

const ProjectOverlayLayout: React.FC = () => {
    const [searchParams] = useSearchParams();
    const fileIdLeft = (searchParams.get('fileId') as string);

    const [fileIdRight, setFileIdRight] = useState<string | undefined>(undefined);

    return fileIdLeft != null ? (
        <ModelingToolsContextProvider>
            <ProjectFilePlanContextProvider 
                fileIdLeft={fileIdLeft}
                fileIdRight={fileIdRight}
                setFileIdRight={setFileIdRight}
            >
                <ProjectOverlayPlanDetails />
            </ProjectFilePlanContextProvider>
        </ModelingToolsContextProvider>
    ) : (
        <MeasureOverviewLayout />
    )
}

export default ProjectOverlayLayout;